module.exports = __webpack_public_path__ + "img/image.a6935ab3.svg";